import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageReview } from '@/api/model/interfaces';

export default class DrawingPackageReviewOdata extends OdataManager<DrawingPackageReview> {}
